<!-- eventManager-dashboard.component.html -->
<div class="event-dashboard">
  <div class="dashboard-header">
    <h2>Event Dashboard</h2>
    <mat-form-field appearance="outline">
      <mat-select [formControl]="timeRange">
        <mat-option value="Today">Today</mat-option>
        <mat-option value="Week">This Week</mat-option>
        <mat-option value="Month">This Month</mat-option>
        <mat-option value="All">All Time</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  @if (metricsLoading$ | async) {
    <mat-spinner diameter="40" class="card-loader"></mat-spinner>
  } @else {
    <div class="metrics-row" id="overall-summaries">
      <div class="appointment-card clickable" (click)="manageEvents()">
        <div class="card-top">
          <div class="grey round newbg">
            <mat-icon>event</mat-icon>
          </div>
        </div>
        <div class="card-middle">
          <div class="large-words">{{ totalEvents$ | async }}</div>
          <div>Total Events</div>
        </div>
      </div>

      <div class="appointment-card">
        <div class="card-top">
          <div class="grey round greenbg">
            <mat-icon>upcoming</mat-icon>
          </div>
        </div>
        <div class="card-middle">
          <div class="large-words">{{ upcomingEvents$ | async }}</div>
          <div>Upcoming</div>
        </div>
      </div>

      <div class="appointment-card">
        <div class="card-top">
          <div class="grey round purplebg">
            <mat-icon>history</mat-icon>
          </div>
        </div>
        <div class="card-middle">
          <div class="large-words">{{ pastEvents$ | async }}</div>
          <div>Past Events</div>
        </div>
      </div>

      <div class="appointment-card">
        <div class="card-top">
          <div class="grey round newbg">
            <mat-icon>groups</mat-icon>
          </div>
        </div>
        <div class="card-middle">
          <div class="large-words">{{ totalAttendees$ | async }}</div>
          <div>Total Attendees</div>
        </div>
      </div>
    </div>

    <button mat-raised-button color="primary" class="create-event-btn" (click)="createEvent()">
      <mat-icon>add</mat-icon> Create Event
    </button>
  }

  <app-upcoming-activities></app-upcoming-activities>
</div>